_onload_functions[_onload_functions.length] = function() {
  jQuery(".confirm").confirm({"msg": I18n.t("Sure?"), "timeout": "3000", "buttons": {"ok": I18n.t("Yes"), "cancel": I18n.t("No"), "separator": " / "}});
};